export const getConversoesMassa = (state) => state.conversoesMassa.lista
export const getIsCarregandoListaConversoesMassa =
  (state) => state.conversoesMassa.isCarregandoLista
